// 🔹 Define TypeScript interfaces
export interface PickType {
  pickId: number;
  pickType: string;
  songOrAlbumName: string;
  artistName: string;
  memberName: string;
  songOrAlbumArt: string;
}

export interface WeekType {
  weekId: number;
  weekName: string;
  weekDate: string;
  spotifyPlaylistLink?: string;
  picks: PickType[];
}

export interface specialSpotifyPlaylistType {
  name: string;
  link: string;
  madeBy: string;
}

export type RoomDayTimeType = {
  day: string;
  room: string;
  time: string;
  onBreak: boolean;
};

export interface groupMeLinkType {
  link: string;
}

export interface interestFormType {
  link: string;
}

export interface instagramLinkType {
  link: string;
}
export interface spotifyLinkType {
  link: string;
}

// 🔹 Define TypeScript Classes with Correct Type Handling
export class Pick {
  constructor(
    public pickId: number,
    public pickType: string,
    public songOrAlbumName: string,
    public artistName: string,
    public memberName: string,
    public songOrAlbumArt: string
  ) {}

  toFirestore(): PickType {
    return { ...this };
  }
}

export class Week {
  constructor(
    public weekId: number,
    public weekName: string,
    public weekDate: string,
    public spotifyPlaylistLink?: string,
    public picks: Pick[] = [] // 🔹 Change to Pick[]
  ) {}

  toFirestore(): WeekType {
    return {
      weekId: this.weekId,
      weekName: this.weekName,
      weekDate: this.weekDate,
      spotifyPlaylistLink: this.spotifyPlaylistLink,
      picks: this.picks.map((pick) => pick.toFirestore()), // 🔹 Use Pick class
    };
  }
}

export class specialSpotifyPlaylist {
  constructor(
    public name: string,
    public link: string,
    public madeBy: string
  ) {}

  toFirestore(): specialSpotifyPlaylistType {
    return {
      ...this,
    };
  }
}

export class groupMeLink {
  constructor(public link: string) {}

  toFirestore(): groupMeLinkType {
    return {
      ...this,
    };
  }
}

export class instagramLink {
  constructor(public link: string) {}

  toFirestore(): instagramLinkType {
    return {
      ...this,
    };
  }
}

export class spotifyLink {
  constructor(public link: string) {}

  toFirestore(): spotifyLinkType {
    return {
      ...this,
    };
  }
}

export class interestForm {
  constructor(public link: string) {}

  toFirestore(): interestFormType {
    return {
      ...this,
    };
  }
}

export interface onceThroughType {
  names: string[];
}
export class onceThrough {
  constructor(public names: string[]) {}
  toFirestore(): onceThroughType {
    return {
      ...this,
    };
  }
}
